import { fetch } from '@/shared/fetch';
import { ICaregiverSpaceConsultationMessageDto } from '@/shared/interfaces';

export const fetchConsultationMessages = (
    consultationUid: string,
): Promise<ICaregiverSpaceConsultationMessageDto[]> => {
    return fetch(
        `/api/caregiverspace/consultations/${consultationUid}/messages`,
        'GET',
    );
};
